const setInputFields = ( metaValues, form ) => {
	Object.keys( metaValues ).forEach( metaKey => {
		/**
		 * @member {HTMLInputElement} inputField
		 */
		const inputField = form.querySelector( 'input[name="' + metaKey + '"]' );

		if ( inputField && metaValues[ metaKey ] && metaValues[ metaKey ].length ) {
			inputField.value = metaValues[ metaKey ];
		}
	} );
};

/**
 * Validates the custom select fields #kundkort.
 *
 * Attaches validation to the checkout form's submit event to ensure that
 * options are selected in these fields.
 */
const validateKortSelectFields = () => {
	const checkoutForm = document.querySelector( 'form.checkout' );

	if ( ! checkoutForm ) {
		return;
	}

	const handleSubmit = event => {
		let hasError = false;

		const kundkort = checkoutForm.querySelector( '#kundkort' );
		if ( kundkort ) {
			const kundkortValue = kundkort?.value;
			if ( kundkortValue === '' || kundkortValue === null ) {
				kundkort.setCustomValidity( 'Please select an option.' );
				hasError = true;
			} else {
				kundkort.setCustomValidity( '' );
			}
		}

		if ( hasError ) {
			event.preventDefault();
			event.stopImmediatePropagation();
			checkoutForm.reportValidity();
		}
	};

	checkoutForm.addEventListener( 'submit', handleSubmit, true );
};

export { setInputFields, validateKortSelectFields };
